import {
  Action,
  AuthState,
  InitializeAction,
  LoginAction,
  RegisterAction,
  UpdateCompanyAction,
  WelcomeScreenAction,
  CompAction,
  BackAction
} from './types';

const handlers: Record<
  string,
  (state: AuthState, action: Action) => AuthState
> = {
  INITIALIZE: (state: AuthState, action: InitializeAction): AuthState => {
    const { isAuthenticated, user } = action.payload;

    return {
      ...state,
      user
    };
  },
  LOGIN: (state: AuthState, action: LoginAction): AuthState => {
    const { user } = action.payload;
    return {
      ...state,
      user
    };
  },
  LOGOUT: (state: AuthState): AuthState => ({
    ...state,
    user: null
  }),
  REGISTER: (state: AuthState, action: RegisterAction): AuthState => {
    const { user } = action.payload;
    return {
      ...state,
      user
    };
  },
  SETDATACOMP: (state: AuthState, action: CompAction): AuthState => {
    return {
      ...state,
      compData: action.payload.compData
    };
  },
  SET_BACK_ACTION: (state: AuthState, action: BackAction): AuthState => {
    return {
      ...state,
      isBack: action.payload.isBack
    };
  }
};

export const reducer = (state: AuthState, action: Action): AuthState =>
  handlers[action.type] ? handlers[action.type](state, action) : state;
